import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Container, Grid, IconButton, Paper, Typography } from "@mui/material";
import RtlProvider from '../../../Components/RtlProvider';
import { ContextNotification, severitys } from '../../../App';
import helper from '../../../helper';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import planAttachmentApi from '../../../api/planAttachmentApi';
import cityApi from '../../../api/cityApi';
import hotelApi from '../../../api/hotelApi';

import { MdDownload } from "react-icons/md";
import AccessControl from '../../../Components/AccessControl';
import { ContextUserInfo } from '../MainPanel';
import Base64Downloader from 'common-base64-downloader-react'
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import staticVariablesApi from '../../../api/staticVariablesApi';
import DeletePlanAttachmentForm from './DeletePlanAttachmentForm';


const PlanAttachmentPanel = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);
  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  // const [rows, setRows] = useState([]);
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);

  const schema = yup.object().shape({

  });
  const { handleSubmit, formState: { errors }, control, resetField, watch } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const hotelId = watch("hotelId");
  const onSubmit = (data) => {
  };

  useEffect(() => {
    GetCityDropDown();
  }, []);

  const RefreshGrid = async (result) => {
    // if(result)
    //   setRefresh(old => !old);

    const planAttachments = await fetchPlanAttachmentsByHotelId(hotelId);
    const hotelFiles = planAttachments?.hotelFiles;
    setData(hotelFiles);
  }

  const handleCityChanged = useCallback(async (id) => {
    resetField("hotelId");
    setHotels([]);
    setData([])
    if (id) {
      const hotels = await fetchHotelsByCityConsistency(id);
      setHotels(
        hotels.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);
  const handleHotelChanged = useCallback(async (id) => {
    // resetField("");
    setData([])
    if (id) {
      const planAttachments = await fetchPlanAttachmentsByHotelId(id);
      const hotelFiles = planAttachments?.hotelFiles;
      setData(hotelFiles);
    }
  }, []);
  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };

  const fetchHotelsByCityConsistency = async (cityConsistency) => {
    try {
      let res = await hotelApi.HotelDropDown(cityConsistency);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };

  const fetchPlanAttachmentsByHotelId = async (hotelId) => {
    setLoadingRows(true);
    try {
      let res = await planAttachmentApi.GetHotelAttachments(hotelId);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
    finally {
      setLoadingRows(false);
    }
  };


  const columns = useMemo(
    () => [
      {
        accessorKey: 'fileName',
        header: 'نام',
        size: 100,
      },
      {
        accessorKey: 'base64File',
        id: 'base64File',
        header: 'دانلود',
        Cell: ({ cell, row }) => (
          <Base64Downloader
            base64={'data:' + row.original.contentType + ";base64," + row.original.base64File}
            downloadName={row.original.fileName}
            Tag="a"
            extraAttributes={{ href: '#' }}
            className="my-class-name"
            style={{ color: 'black' }}
            onDownloadSuccess={() => { }}
            onDownloadError={() => { }}
          >
            {<IconButton>
              <MdDownload color="inherit" size="20px" />
            </IconButton>
            }
          </Base64Downloader>
        ),
        size: 100,
        enableSorting: false,
      },


    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: {
      sorting: [

      ],
    },
    state: {
      isLoading: loadingRows,
    },
    enableRowSelection: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enablePagination: false,
    enableSorting: true,
    enableColumnActions: false,

    mrtTheme: (theme) => ({
      baseBackgroundColor: theme.palette.background.default, //change default background color
    }),

    muiTableProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',

      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: '#86A7FC',
        fontWeight: 'bold',
        textAlign: 'left'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        textAlign: 'left'
      },
    },
    enableRowActions: true,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text
        size: 300, //make actions column wider

      },
    },
    renderRowActions: ({ row, table }) => (

      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
        {
          AccessControl.checkPermissions(userPermissions, ["PlanAttachment:Delete"]) &&
          <DeletePlanAttachmentForm id={row.original.id} refreshGrid={RefreshGrid} />
        }

      </Box>
    ),
  });

  return (

    <Container component="main">
      <form onSubmit={handleSubmit(onSubmit)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2}>
            لیست پلان مهندسی هتل
          </Typography>
          <Grid container spacing={1} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                control={control}
                options={Cities ?? []}
                name="CityConsistency"
                placeholder="شهر"
                onChange={handleCityChanged}
                disabled={Cities === null}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                control={control}
                options={Hotels ?? []}
                name="hotelId"
                placeholder="هتل"
                onChange={handleHotelChanged}
                disabled={Cities === null}
              />
            </Grid>
          </Grid>
          <MaterialReactTable table={table} />
        </RtlProvider>
      </form>


    </Container>
  )
}
export default PlanAttachmentPanel;